import { TunnelStep } from '../model/tunnel-step-type';
import { Configurator2DSelectionComponent } from '../../configurators-2d/selector/configurators-2d-selection.component';
import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';

export const CLOSET_DOORS_TUNNEL_STEPS: TunnelStep[] = [
  {
    component: Configurator2DSelectionComponent,
    context: CONFIG_CONTEXT.CLOSET_DOORS,
  },
];
